import React from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//material ui:
import DatePicker from '../../utils/DatePicker';
//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';

const styles = theme => ({
    root: {
        height: '100%',
        width: 240,
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        marginLeft: 25,
        marginTop: 35,
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 20px',
        marginBottom: 20,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
});

class EditLicenciaMaquina extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.licencia.id ? this.props.licencia.id : uuidv4(),
            maquinaId: this.props.licencia.maquinaId
                ? this.props.licencia.maquinaId
                : this.props.maquinaId,
            maquina: this.props.licencia.maquina
                ? this.props.licencia.maquina
                : null,
            licencia: this.props.licencia.licencia
                ? this.props.licencia.licencia
                : '',
            fechaInicio: this.props.licencia.fechaInicio
                ? this.props.licencia.fechaInicio.slice(0, 10)
                : new Date().toJSON().slice(0, 10),
            fechaFin: this.props.licencia.fechaFin
                ? this.props.licencia.fechaFin.slice(0, 10)
                : new Date().toJSON().slice(0, 10),
        };
    }

    //textfield
    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };
    handleValueChangeDate = (event, field) => {
        this.setState({ ...this.state, [field]: event });
    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <TextField
                            id={'licencia'}
                            label={'Licencia'}
                            placeholder={'Licencia'}
                            margin="normal"
                            autoFocus
                            value={this.state.licencia}
                            onChange={event =>
                                this.handleValueChange(event, 'licencia')
                            }
                        />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        {/* <TextField
                            id={'fechaInicio'}
                            label={'Fecha Inicio'}
                            placeholder={'Fecha Inicio'}
                            type="date2"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            margin="normal"
                            value={this.state.fechaInicio}
                            onChange={(event) => this.handleValueChange(event, 'fechaInicio')}
                        /> */}
                        <DatePicker
                            label={'Fecha Inicio'}
                            value={this.state.fechaInicio}
                            onChange={event => {
                                if (event && !isNaN(event)) {
                                    const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                    this.handleValueChangeDate(d.toISOString().slice(0, 10), 'fechaInicio')
                                }
                            }}
                        />
                    </FormControl>
                </div>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        {/* <TextField
                            id={'fechaFin'}
                            label={'Fecha Fin'}
                            placeholder={'Fecha Fin'}
                            type="date2"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            margin="normal"
                            value={this.state.fechaFin}
                            onChange={(event) => this.handleValueChange(event, 'fechaFin')}
                        /> */}
                        <DatePicker
                            label={'Fecha Fin'}
                            value={this.state.fechaFin}
                            onChange={event => {
                                if (event && !isNaN(event)) {
                                    const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                    this.handleValueChange(d.toISOString().slice(0, 10), 'fechaFin')
                                }
                            }}
                        />
                    </FormControl>
                </div>

                <div className={classes.buttonsContainer}>
                    <Button
                        className={classes.buttonsBottom}
                        variant="contained"
                        color="secondary"
                        onClick={() => this.props.hideDialog()}
                    >
                        Cerrar
                    </Button>
                    <Button
                        className={classes.buttonsBottom}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            const licencia = {
                                id: this.state.id,
                                maquinaId: this.state.maquinaId,
                                maquina: this.state.maquina,
                                licencia: this.state.licencia,
                                fechaInicio: this.state.fechaInicio,
                                fechaFin: this.state.fechaFin,
                            };

                            if (this.props.checkLicencia(licencia)) {
                                this.props.okHandler(licencia);
                                this.props.hideDialog();
                            }
                        }}
                    >
                        Guardar
                    </Button>
                </div>
            </div>
        );
    }
}

EditLicenciaMaquina.propTypes = {
    licencia: PropTypes.object.isRequired,
    maquinaId: PropTypes.number.isRequired,
    okHandler: PropTypes.func.isRequired,
    checkLicencia: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(EditLicenciaMaquina);
